import fetch from 'isomorphic-fetch'
import { deleteApi, post, put, get } from '../utils'
class UserConversationsApi {
  static requestHeaders() {
    return {
      'Content-Type': 'application/json',
      AUTHORIZATION: `Bearer ${localStorage.jwt}`
    }
  }

  static getAll(userId) {
    const headers = this.requestHeaders()

    return fetch(`${process.env.REACT_APP_API_HOST}/users/${userId}/user_conversations`, {
      method: 'GET',
      headers: headers
    })
      .then((response) => response.json().then((json) => ({ json, response })))
      .catch((error) => {
        return error
      })
  }

  static update(conversationId, id, user_conversation) {
    return put(`/conversations/${conversationId}/user_conversations/${id}`, {
      body: JSON.stringify({ user_conversation })
    })
  }

  static getAllByConversationId(conversationId) {
    const headers = this.requestHeaders()

    return fetch(`${process.env.REACT_APP_API_HOST}/conversations/${conversationId}/user_conversations`, {
      method: 'GET',
      headers: headers
    })
      .then((response) => response.json().then((json) => ({ json, response })))
      .catch((error) => {
        return error
      })
  }
}

export default UserConversationsApi
